<template>
	<div class="d-flex justify-content-between">
		<div
			v-if="item && item.name"
			class="item-option d-flex pt-1px"
			:class="`type-${type}`">
			<!-- Icon -->
			<component
				class="mr-3"
				:class="{'rundown-icon': item.layer_index}"
				:is="icon"
				:size="14"
				:title="' '"
			/>
			<div v-if="item && item.name && !shortField" class="truncate-item-assets-name">{{ item && item.name ? item.name : 'item' }}</div>
			<div v-if="item && item.name && shortField" class="truncate-item-assets-name-short">{{ item && item.name ? item.name : 'item' }}</div>
		</div>
		<div
			v-else
			class="item-option d-flex type-rundown">
			<!-- Icon -->
			<i class="material-icons md-18 p-0 h-fc mr-2 pr-1">playlist_play</i>
			<div v-if="status === 'clear_output'">Clear Output Command</div>
			<div v-if="status === 'stop_all'">Stop All Command</div>
			<div v-if="status === 'play_previous'">Play Previous Command</div>
			<div v-if="status === 'play_next'">Play Next Command</div>
		</div>
		<div>
			<div class="capitalize index-macro-not-edit" v-if="itemMacro">{{ itemMacro && itemMacro.rundownItem && itemMacro.rundownItem.layer_index ? itemMacro.rundownItem.layer_index : '' }}</div>
		</div>
		<!-- status / action -->
		<div class="text-center">
			<div class="capitalize mr-2 action-macro-not-edit" v-if="itemMacro">{{ itemMacro.status.replace(/_/g, ' ') }}</div>
		</div>
		<!-- delay -->
		<div>
		</div>
		<div class="absolute mr-31em">
			<div class="capitalize" v-if="itemMacro">{{ itemMacro && itemMacro.delay && itemMacro.delay ? itemMacro.delay : '' }}</div>
		</div>
	</div>
</template>

<script>
import EarthIcon from 'vue-material-design-icons/Earth.vue';
import PlaylistPlayIcon from 'vue-material-design-icons/PlaylistPlay.vue';
import StopIcon from 'vue-material-design-icons/Stop.vue';
import ImageIcon from 'vue-material-design-icons/Image.vue';
import AlphaAIcon from 'vue-material-design-icons/AlphaA.vue';
import FormatSizeIcon from 'vue-material-design-icons/FormatSize.vue';
import RadioTowerIcon from 'vue-material-design-icons/RadioTower.vue';
import VideoIcon from 'vue-material-design-icons/Video.vue';
import ClockIcon from 'vue-material-design-icons/Clock.vue';
import PictureInPictureIcon from 'vue-material-design-icons/PictureInPictureBottomRightOutline.vue';
import TransitionIcon from 'vue-material-design-icons/Transition.vue';
import MovieIcon from 'vue-material-design-icons/Filmstrip.vue';
import FormatTextRotationNoneIcon from 'vue-material-design-icons/FormatTextRotationNone.vue';
import ViewCompactIcon from 'vue-material-design-icons/ViewCompact.vue';
import WebcamIcon from 'vue-material-design-icons/Webcam.vue';
import CubeIcon from 'vue-material-design-icons/Cube.vue';
import MusicIcon from 'vue-material-design-icons/Music.vue';

import { getRundownItemIcon } from '@/lib/helper';

export default {
	name: 'ItemOption',
	props: {
		isEdit: {
			type: Boolean,
		},
		item: {
			type: Object,
		},
		itemMacro: {
			type: Object,
		},
		shortField: {
		},
	},
	components: {
		PlaylistPlayIcon,
		EarthIcon,
		ImageIcon,
		AlphaAIcon,
		FormatSizeIcon,
		RadioTowerIcon,
		VideoIcon,
		ClockIcon,
		PictureInPictureIcon,
		TransitionIcon,
		MovieIcon,
		FormatTextRotationNoneIcon,
		ViewCompactIcon,
		StopIcon,
		WebcamIcon,
		CubeIcon,
		MusicIcon,
	},
	computed: {
		type() {
			return this.item && this.item.type ? this.item.type : 'rundown';
		},
		icon() {
			const icon = getRundownItemIcon(this.type);
			return `${icon}-icon`;
		},
		status() {
			return this.itemMacro && this.itemMacro.status ? this.itemMacro.status : '';
		},
	},
};
</script>
